<p-breadcrumb [model]="model">
  <ng-template let-item pTemplate="item">
    <span [ngClass]="{ 'p-breadcrumb-selected': item.selected }">{{
      item.label
    }}</span>
  </ng-template>

  <ng-template let-item pTemplate="separator"> > </ng-template>
</p-breadcrumb>
